import React from "react";
import { Helmet } from "react-helmet";
import styles from "../style.module.scss";
import { PageBanner } from "../../../../components/parts/section";
import { productData } from "../../../../utils/constants";
import { CommonProductPage } from "../../../../components/parts";

const MsPipes = () => {
  const singleProductData = productData.filter((val) => val.id === 4);
  return (
    <>
      <Helmet>
        <title>Mild Steel Pipe & Black Pipe Suppliers, Calgary</title>
        <meta
          name="description"
          content="APF Steel is one of leading Mild Steel Pipe, Black Pipe manufacturers and suppliers in Calgary. MS pipe can be used in industrial and chemical equipment."
        />
      </Helmet>
      <div className={styles.productInnerPage}>
        <PageBanner image={singleProductData[0].featured_image} />
        <CommonProductPage
          title={singleProductData[0].name}
          description={singleProductData[0].description}
          features={singleProductData[0].product_feature}
          gallery={singleProductData[0].productGallery}
        />
      </div>
    </>
  );
};

export default MsPipes;
